import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError, Observable, catchError } from 'rxjs';
import { environment } from 'src/app/environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RequestService {
  constructor(public http: HttpClient, private router: Router) {}
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  base_url = environment.apiUrl;

  resendRequest(id: any): Observable<any> {
    return this.http
    .get(this.base_url + `api/v1/requests/organization/retry/${id}`)
    .pipe(
        catchError((error:any) => {
            return throwError(error);
        })
    );
}

  getRequests(
    page: number,
    limit: number,
    fromDate: any,
    toDate: any,
    responseState: string,
    method: string,
    search: string,
    webhookConfigId: string
  ): Observable<any> {
    return this.http
      .get(
        this.base_url +
          `api/v1/requests/dashboard?page=${page}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}&responseState=${responseState}&method=${method}&search=${search}&webhookConfigId=${webhookConfigId}`
      )
      .pipe(
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }
}
